import { ReactNode, useState } from 'react';
import TourBag from '../../components/TourBag';
import { NavbarSlotContext } from '@/context/NavbarSlotContext';
import { TourBagNavbar } from '@/layout/TourBagNavbar/TourBagNavbar';
import styles from './TourBagPage.module.scss';

function TourBagPage() {
  const [navbarSlot, setNavbarSlot] = useState<ReactNode>(null);

  return (
    <NavbarSlotContext.Provider value={{ setSlot: setNavbarSlot }}>
      <div className={styles.tourPageLayout}>
        <TourBagNavbar slot={navbarSlot} />
        <main className={`${styles.main} ${styles.navbarOffset}`}>
          <TourBag />
        </main>
      </div>
    </NavbarSlotContext.Provider>
  );
}

export default TourBagPage;
